import React, { FC, PropsWithChildren, ReactNode } from 'react';
import classNames from 'classnames';

import { FormControlSize } from './types';

import Caption from './Caption';

import styles from './FormControl.module.scss';


export type FormControlProps = PropsWithChildren<{
  inline?: boolean;
  label?: ReactNode;
  caption?: ReactNode;
  error?: ReactNode;
  size?: FormControlSize;
  className?: string;
  linkNote?: ReactNode;
  'data-test'?: string;
}>;

export const FormControl: FC<FormControlProps> = ({
  inline = false,
  size = FormControlSize.MEDIUM,
  label,
  caption,
  error,
  children,
  className,
  linkNote,
  ...props
}) => {
  return (
    <div
    className={classNames(styles.formControl, styles[size], {
      [styles.inline]: inline,
      [styles.labelControl]: label,
    }, className)}>
      <label className={styles.label}>
        {label && typeof (label) === 'string' ? <span className={styles.labelText}>{label}</span> : label}
        {children}
      </label>
      {getCaption(error, caption, linkNote, props['data-test'])}
    </div>
  );
};

function getCaption(
  error?: ReactNode,
  caption?: ReactNode,
  linkNote?: ReactNode,
  dataTest?: string,
) {
  if (!error && caption) {
    return (
      <>
        <Caption data-test={classNames(dataTest, 'FormControl_caption')}>
          {caption}
        </Caption>
        {linkNote && <span>{linkNote}</span>}
      </>
    );
  }

  if (error) {
    return (
      <>
        <Caption error
                 data-test={classNames(dataTest, 'FormControl_errorCaption')}>
          {error}
        </Caption>
        {linkNote && <span>{linkNote}</span>}
      </>

    );
  }

  if (linkNote) {
    return <>{ linkNote }</>;
  }
}
